// ** Icons Import
import ReactFreshchat from "react-freshchat"
import { getUserData } from "../../../../utility/Utils"


const Footer = () => {

  const user = getUserData()?.user
  return (
    <>
      {user ? <ReactFreshchat
        token={'298c45e6-a383-491f-84aa-50e9b2d22967'}
        externalId={`${user.id}`}
        firstName={`${user.username}`}
        email={`${user.email}`}
      /> : <ReactFreshchat
        token="298c45e6-a383-491f-84aa-50e9b2d22967"
      />}


      <p className="clearfix mb-0">
        <span className="float-md-start d-block d-md-inline-block mt-25">
          COPYRIGHT &copy; 2021 - {new Date().getFullYear()}
          <a className="ms-25" href="https://betfolio.io">
            Betfolio
          </a>
          <span className="d-none d-sm-inline-block">, All rights Reserved</span>
        </span>
      </p>
      <div id="Freshchat-js-sdk" />
    </>
  )
}

export default Footer
